import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb } from 'react-icons/fi'
import Layout from '../components/Layout/Layout'

const DeleteUser = () => {

  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Aviso de Privacidad
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-4">
              Eliminación de cuenta
            </h1>
          </div>
                    
          {/* Privacy List - Static Display */}
          <div className="space-y-6">
            <p>
                Los usuarios pueden eliminar su cuenta directamente desde la aplicación
                móvil.
            </p>

            <h2>Cómo eliminar tu cuenta</h2>

            <ol>
              <li>Inicia sesión en la aplicación.</li>
              <li>Ve a <strong>Configuración</strong>.</li>
              <li>Después<strong>Mi perfil</strong>.</li>
              <li>Selecciona <strong>Eliminar cuenta</strong>.</li>
              <li>Confirma la eliminación.</li>
            </ol>

            <h2>¿Qué datos se eliminan?</h2>

            <p>
                Al eliminar tu cuenta se eliminarán tus datos personales, direcciones,
                historial de sesión y demás información asociada a tu perfil.
            </p>

            <p>
                Los registros de compras o información que debamos conservar por
                obligaciones legales o fiscales podrán mantenerse durante el tiempo
                exigido por la legislación aplicable.
            </p>

            <h2>¿Necesitas ayuda?</h2>

            <p>
                Escríbenos a <strong>contactocoronasarca@gmail.com</strong>.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default DeleteUser